import AsyncStorage from '@react-native-async-storage/async-storage';
import type { Credentials } from 'react-native-auth0';

type GetCredentialsFn = () => Promise<Credentials | void>;
type AuthFailureFn = () => Promise<void>;

let _getCredentials: GetCredentialsFn | null = null;
let _onAuthFailure: AuthFailureFn | null = null;

export const initAuthBridge = (
  getCredentials: GetCredentialsFn,
  onAuthFailure: AuthFailureFn,
): void => {
  _getCredentials = getCredentials;
  _onAuthFailure = onAuthFailure;
};

export const tryRefreshToken = async (): Promise<string | null> => {
  if (!_getCredentials) return null;
  try {
    const creds = await _getCredentials();
    const token = (creds as Credentials | null)?.accessToken ?? null;
    if (token) await AsyncStorage.setItem('auth_token', token);
    return token;
  } catch {
    return null;
  }
};

export const triggerAuthFailure = async (): Promise<void> => {
  await AsyncStorage.removeItem('auth_token');
  await _onAuthFailure?.();
};
